module.exports = __webpack_public_path__ + "img/smoobu-logo-blue.26aa2e6a.png";